module.exports = __webpack_public_path__ + "img/dmu-rag.c2d883c9.svg";